
import { textToHTML } from "@/utilities/textToHtml";

/**
 * Replace <img> tags with SVG content dynamically using jQuery.
 *
 *
 * This function targets all <img> tags with the class 'svg' and replaces them.
 * It preserves the ID, class, and size attributes of the original <img> tag.
 */
const imgSvgs = /** @type {NodeListOf<HTMLImageElement>} */( document.querySelectorAll( 'img.svg' ) );
imgSvgs.forEach( function( img ) {
    const id = img.id;
    const classList = img.classList.toString();
    const url = img.src;
    const ext = url.split( '.' ).pop();
    if ( ext !== 'svg' ) return;

    fetch( url ).then( async ( res ) => {
        const svgString = await res.text();
        const svg = textToHTML( svgString );
        if ( !svg ) return;

        if ( id ) svg.id = id;
        if ( classList ) svg.setAttribute( 'class', classList );
        svg.classList.add( 'replace-svg' );
        const height = svg.getAttribute( 'height' );
        const width = svg.getAttribute( 'width' );
        if ( !svg.getAttribute( 'viewBox' ) && height && width ) {
            svg.setAttribute( 'viewBox', `0 0 ${height} ${width}` );
        }

        img.replaceWith( svg );
    } ).catch( e => {
        console.warn( e );
    } );
} );

/**
 * When an element with the back-to-top class is clicked, animate
 * the user to scroll them back to the top of the page.
 */
const scrollDown = document.querySelector('#homepageBannerArrow');
const homepageBanner = document.querySelector('#homepageBanner');
const nextSibling = homepageBanner?.nextElementSibling;

scrollDown?.addEventListener('click', scrollDownAnimation);

function scrollDownAnimation() {
    nextSibling?.scrollIntoView({ behavior: 'smooth' });
}